export default __webpack_public_path__ + "static/media/c_mobile_dr_04.42bdcc25.png";